module.exports = require('../build/DayPickerInput');



//////////////////
// WEBPACK FOOTER
// ../node_modules/react-day-picker/DayPickerInput/index.js
// module id = 200
// module chunks = 16